import { FramerPage } from 'Pages/FramerPage';

const TermsAndConditions = () => <FramerPage path="terms-and-conditions" />;

export default TermsAndConditions;
